import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesignAngularKitModule, IconName } from 'design-angular-kit';
import { Note } from '../../../../models/note.dto';

@Component({
  selector: 'app-note-card',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './note-card.component.html',
  styleUrl: './note-card.component.scss'
})
export class NoteCardComponent {
  @Input() note!: Note;
}
